import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { Badge } from "@eudonet/opal";
import { useI18n } from "vue-i18n";
import { resolveCampaignStatusBadge } from "./campaignStatusBadge";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CampaignStatusBadge',
    props: {
        status: {}
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const config = computed(() => resolveCampaignStatusBadge(props.status));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Badge), {
                label: _unref(t)(config.value.labelKey),
                theme: config.value.theme,
                size: "sm",
                "show-left-icon": false,
                "show-close-icon": false
            }, null, 8 /* PROPS */, ["label", "theme"]));
        };
    }
});
